import Preloader from '../checkout/components/Partials/Preloader.vue';
import { mapActions } from 'vuex';
import storage from '../checkout/services/storage';
import AdditionOptions from "./Types/AdditionOptions.vue";
import Device from "./Types/Device.vue";
import { mapGetters } from "vuex";
import MobileTariff from "./Types/MobileTariff.vue";
import TvTariff from "./Types/TvTariff.vue";

export default {
    props: ['checkout', 'additional', 'translations'],

    components: {
        Preloader,
        Device,
        MobileTariff,
        TvTariff,
        AdditionOptions
    },

    data() {
        return {
            checkoutData: {}
        }
    },

    methods: {
        ...mapActions(['updateCheckout']),
    },

    created(){
        let checkoutData = JSON.parse(this.checkout);

        storage.save('checkout-id', checkoutData.id, true);
        storage.save('page-step', 1, true);
        this.$i18nApi.setTranslations(JSON.parse(this.translations));
        this.checkoutData = checkoutData;
        this.updateCheckout(checkoutData);
    }
}
